import { Injectable } from '@angular/core';
import { RestApiService } from 'app/modules/shared/services/rest-api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DriverTimeService {

  constructor(
    private restApiService: RestApiService,
  ) {}

  updateStatus(id: any, data: any, eventId): Observable<any> {
    return this.restApiService.put(`/secure/shift-management/shifts/update-duty-status/${id}?eventId=${eventId}`, data, 'page-center');
  }

  getDriver(): Observable<any> {
    return this.restApiService.get( `/secure/drivers/list/data`, 'page-center');
  }

  saveGlobalTime(data): Observable<any> {
    return this.restApiService.post( `/secure/shift-management/shifts`, data, 'page-center');
  }

  assignTripId(driverId, data): Observable<any> {
    return this.restApiService.put( `/secure/driver-schedule/assign-driver/${driverId}`, data, 'page-center');
  }

  updateGlobalTime(id, data): Observable<any> {
    return this.restApiService.put( `/secure/shift-management/shifts/${id}`, data, 'page-center');
  }

  getGlobalTime(id): Observable<any> {
    return this.restApiService.get( `/secure/shift-management/shifts/${id}`, 'page-center');
  }

  getUnassosiatedDrivers(eventId, serviceAreaId): Observable<any> {
    return this.restApiService.get(`/secure/shift-management/users?searchText=&offset=0&limit=100000&eventId=${eventId}&serviceAreaId=${serviceAreaId}`, 'page-center');
  }

  getGlobalTimeDriverList(search, offset, id?): Observable<any> {
    return this.restApiService.get( `/secure/global-time-group/drivers/list?shiftId=${id}&searchText=${search}&limit=200&offset=${offset}`, 'page-center');
  }


  getDriverSchedule(driverId, globalId, fromDate, toDate, offset, limit, eventId, serviceAreaId?, viewType?, fromDateStr?, toDateStr?): Observable<any> {
        return this.restApiService.get( `/secure/driver-schedule/list/data?driverId=${driverId}&shiftId=${globalId}&limit=${limit}&offset=${offset}&fromDate=${fromDate}&toDate=${toDate}&eventId=${eventId}&serviceAreaId=${serviceAreaId}&viewType=${viewType}&fromDateStr=${fromDateStr}&toDateStr=${toDateStr}`, 'page-center');
  }

  getAssignDriverSchedule(searchText, globalId, fromDate, toDate, offset, limit, eventId): Observable<any> {
    return this.restApiService.get( `/secure/driver-schedule/assign-driver/list/data?searchText=${searchText}&shiftId=${globalId}&limit=${limit}&offset=${offset}&fromDate=${fromDate}&toDate=${toDate}&eventId=${eventId}`, 'page-center');
  }

  getDriverScheduleDrivers(eventId, serviceAreaIds): Observable<any> {
    return this.restApiService.get( `/secure/driver-schedule/drivers/list?searchText=&limit=0&offset=0&eventId=${eventId}&serviceAreaId=${serviceAreaIds}`, 'page-center');
  }

  getDayOffList(eventId, scheduleType): Observable<any> {
    return this.restApiService.get( `/secure/day-off-status/list?eventId=${eventId}&scheduleType=${scheduleType}`, 'page-center');
  }

  getDriverScheduleGroups(eventId, serviceAreaIds = ''): Observable<any> {
    return this.restApiService.get( `/secure/shift-management/shifts?projection=non-grid&eventId=${eventId}&serviceAreaId=${serviceAreaIds}`, 'page-center');
  }

  addSchedule(payload): Observable<any> {
    return this.restApiService.post( `/secure/driver-schedule`, payload, 'page-center');
  }

  updateSchedule(payload): Observable<any> {
    return this.restApiService.put( `/secure/driver-schedule/schedule/using-date`, payload, 'page-center');
  }

  getVehicleScheduleVehicleList(eventId): Observable<any> {
    return this.restApiService.get( `/secure/vehicle-schedule/vehicle/list?searchText=&limit=0&offset=0&eventId=${eventId}`, 'page-center');
  }

  getVehicleSchedule(driverId, globalId, fromDate, toDate, offset, limit, eventId, serviceAreaId, viewType, fromDateStr, toDateStr): Observable<any> {
    return this.restApiService.get( `/secure/vehicle-schedule/list/data?vehicleId=${driverId}&limit=${limit}&offset=${offset}&fromDate=${fromDate}&toDate=${toDate}&eventId=${eventId}&serviceAreaId=${serviceAreaId}&viewType=${viewType}&fromDateStr=${fromDateStr}&toDateStr=${toDateStr}`, 'page-center');
  }

  addVehicleSchedule(payload): Observable<any> {
    return this.restApiService.post( `/secure/vehicle-schedule/add`, payload, 'page-center');
  }

  updateVehicleSchedule(payload): Observable<any> {
    return this.restApiService.put( `/secure/vehicle-schedule/schedule/using-date`, payload, 'page-center');
  }
}
